<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2019-12-18 16:50:14
 * @LastEditors: mrh
 * @LastEditTime: 2022-11-09 14:51:18
-->
<template>
  <div class="content" style="font-size: 12px;text-align: left;">
    <div class='cont' v-if="type==47">
      <p style="text-align: center;;"><strong>MassAI用户协议</strong></p>
      <p>
        《MassAI用户协议》（以下简称&ldquo;本协议&rdquo;）由您（用户，即乙方）与MassAI（以下又称&ldquo;MassAI&rdquo;，即甲方）共同缔结，本协议具有合同效力。为使用MassAI，您应当阅读并遵守本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议。<strong>限制、免责条款在正文中可能以黑体加粗形式提示您注意。同时为了便于您迅速阅读和了解相关条款，我们将部分限制、免责条款的简要内容在下方进行展示，请您务必仔细阅读并理解其含义。同时请注意，该部分条款的展示仍然不能代替您对全文的阅读和同意，仅是我们的特别提醒。</strong>
      </p>
      <p><strong>1、</strong><strong>条简要内容：授权平台处理纠纷的内容和风险。</strong></p>
      <p><strong>2 、</strong><strong>条简要内容：平台针对您的违约行为所采取的措施。</strong></p>
      <p><strong>2.1、&nbsp;</strong><strong>条简要内容：诉讼管辖为甲方所在地。</strong></p>
      <p><strong>除非您已阅读并接受本协议所有条款，否则您无权使用MassAI提供的服务。</strong>您使用MassAI用户即视为您已阅读并同意上述协议的约束。</p>
      <p><strong>如果您未满</strong><strong>18</strong><strong>周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。</strong></p>
      <p><strong>一、本协议的订立</strong></p>
      <p>1.1本协议由MassAI与您共同缔结，具有合同效力。</p>
      <p>1.2&nbsp;<strong>您一经勾选</strong><strong>&ldquo;</strong><strong>【同意】</strong><strong>&rdquo;</strong><strong>并使用MassAI许可登录的账户登录MassAI，即意味着您同意与MassAI签订本协议并自愿受本协议约束，并对MassAI与您之间具有法律效力。</strong></p>
      <p>1.3本协议指本协议正文、MassAI的平台规则、其修订版本以及其他MassAI所列明的所有规则性文件、通知或其他内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。您对前述任何协议、规则的接受，即视为您对本协议全部的接受。</p>
      <p>1.4本协议各条的标题仅为方便阅读而设，无意成为本协议的一部分，也不影响本协议的含义或解释。</p>
      <p><strong>二、定义和解释</strong></p>
      <p>2.1&nbsp;<strong>MassAI：</strong>指由MassAI提供技术支持和交易服务的互联网平台，为包括但不限于：本站以及MassAI提供技术服务或运营的移动端平台。随着MassAI用户范围或服务项目的变更，MassAI可能在平台规则或公告中对MassAI的范围或域名调整予以声明。</p>
      <p>2.2&nbsp;<strong>平台规则：</strong>指在MassAI上已经发布或将来可能发布的各种规范性文件，包括但不限于细则、规范、政策、通知等规范性文件。</p>
      <p>2.3&nbsp;<strong>平台服务：</strong>指MassAI依托MassAI向用户提供的网络空间、技术支持、相关的软件服务、系统维护，以及同意向用户提供的各项附属功能等。具体服务内容及功能以MassAI在各个平台上提供的具体服务内容为准。</p>
      <p>2.4&nbsp;<strong>用户：</strong>指使用MassAI用户的自然人、法人或其他组织，本协议中又称&ldquo;您&rdquo;。</p>
      <p>2.5<strong>账户：</strong>或称&ldquo;MassAI账户&rdquo;，指用户所拥有的经MassAI认可，可以登录MassAI的一个合法获得并持有的服务账户（该账户形式可能是在MassAI注册所获得的MassAI账户、手机号、电子邮箱等MassAI支持的其他形式账户，具体哪种形式账户可以登录MassAI，以MassAI公布为准。</p>
      <p>
        2.6<strong>关联公司：</strong>本协议所称一方的&ldquo;关联公司&rdquo;是指由一方直接控制或间接控制；或直接或间接控制一方；或与一方共同控制同一家公司或能对其施加重大影响；或与一方受同一家公司直接或间接控制的公司。包括但不限于一方的母公司、子公司；与一方受同一母公司控制的子公司；一方的合营企业、联营企业等。&ldquo;控制&rdquo;是指直接或间接地拥有影响所提及公司管理的能力，无论是通过所有权、有投票权的股份、合同或其他被人民法院认定的方式。
      </p>
      <p><strong>三、协议的生效与变更</strong></p>
      <p>3.1 MassAI有权在必要时修改本协议条款并会在修改生效前以公告的形式向您告知，您可以在公示期间就协议条款变更的部分充分提出意见。您可以在MassAI用户的相关页面查阅、下载最新版本的协议条款。</p>
      <p>3.2 本协议条款变更公示期间届满，如果您继续使用MassAI提供的软件或服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应终止本协议，并停止使用MassAI提供的软件或服务。</p>
      <p><strong>四、注册用户和账户</strong></p>
      <p><strong>4.1&nbsp;</strong><strong>用户使用MassAI用户应具备完全民事行为能力；用户若不具备前述资格，则用户的监护人应承担因此而导致的一切后果，且MassAI有权注销或永久冻结用户的账户。</strong></p>
      <p><strong>4.2&nbsp;</strong><strong>用户使用MassAI用户必须拥有经MassAI认可登录MassAI的一个合法获得并持有的服务账户；用户对前述账户的申请、使用等行为应符合本协议及注册该账户时与相应的第三方账户服务提供者所签订的注册协议、服务协议以及其他有关规则。用户应自行确保上述账户及其密码的安全，并对利用上述账户及其密码所进行的一切行为负完全责任。</strong></p>
      <p><strong>4.3</strong><strong>您设置的用户名不得违反国家法律法规，否则MassAI可回收您的会员名。</strong></p>
      <p><strong>4.4&nbsp;</strong><strong>您理解并同意，若您的行为违反本协议的相关规定，您的用户资格和账户可能被注销、暂时冻结或永久冻结。</strong></p>
      <p><strong>4.5&nbsp;</strong><strong>如用户使用相关功能，应依据MassAI的认证流程（包括签订相应协议）完成相应平台用户认证。</strong></p>
      <p><strong>4.6</strong><strong>您有权根据平台所规定的程序和要求，对您的用户信息进行查询、更正、删除以及注销。删除或注销用户信息后，MassAI有权基于相关法律法规以及网络安全角度的考虑，在平台设定的保护期内继续保存但不使用您的用户信息等数据。保护期届满，MassAI将永久地、不可逆地删除您的用户信息和交易信息等数据。</strong></p>
      <p><strong>五、用户信息收集、使用和保护</strong></p>
      <p>5.1 MassAI在提供服务的过程中，可能涉及收集、存储、使用、共享和保护您的个人信息。在您使用MassAI提供的服务时，我们将依据MassAI《隐私政策》执行相关个人信息的收集、共享和使用。</p>
      <p>
        5.2MassAI将采取适当措施，根据相关法律的要求，对用户信息提供充分的信息安全保障。用户应妥善保管、使用其用户信息，包括账户号码及其密码、联系方式等信息，因上述信息泄露而导致您的任何损失，包括使用MassAI上的任何第三方应用软件造成信息泄露而导致您的任何损失，由您独立承担责任。如您泄露上述任何信息，您还应及时将泄露的情况以有效方式立即通知MassAI，以便MassAI在合理时间内采取措施防止损失继续扩大，但MassAI对采取措施前已经产生的后果不承担任何责任。
      </p>
      <p>5.3MassAI保证不对外公开或向任何第三方提供您的个人信息，但是存在下列情形之一的除外</p>
      <p>5.3.1公开或提供相关信息之前获得您许可的；</p>
      <p>5.3.2根据法律或政策的规定而公开或提供的；</p>
      <p>5.3.3只有公开或提供您的个人信息，才能提供您需要的服务的；</p>
      <p>5.3.4根据国家权力机关要求公开或提供的；</p>
      <p>5.3.5根据本协议其他条款约定而公开或提供的。</p>
      <p><strong>5.4</strong><strong>为了向您提供更优质的MassAI用户，提升使用体验，您同意MassAI可将您的个人信息提供给为MassAI的关联公司。</strong></p>
      <p><strong>5.5</strong><strong>您理解并认同，在平台方发生重组、解散、破产清算、并购等情况时，平台方可能会向第三方出售或转让MassAI。在该等交易中，作为MassAI不可分割的一部分，您的用户信息也可能将被转让给该第三方，以使该第三方可以继续为您提供服务。</strong></p>
      <p><strong>八、用户行为规范</strong></p>
      <p>8.1 遵守法律法规、社会公德及本协议</p>
      <p>您在使用MassAI用户中的所有行为应遵守国家法律、法规、规章、规范性文件等规定及本协议的规定和要求，不违背社会公德，不损害国家或者任何第三人的任何合法权益。否则，产生的一切法律后果均由您独立承担，并应确保MassAI免于承担任何责任。</p>
      <p>8.2 遵守MassAI规则及相应流程要求</p>
      <p>
        您在使用MassAI用户中的所有行为应遵守MassAI所实时公布的平台规则；如您需要开通、申请或使用MassAI所公示提供的不同服务或为取得该种服务的相应资格，您应依据MassAI所公示的相应具体规则及流程要求完成相应资格的认证与申请，提供开通相应服务所必须的相应资料和信息并保证该等信息的真实和准确；您应与MassAI或提供该具体服务的相应主体签订协议（如需要），并严格履行该等协议；您使用该等服务的具体内容以相应协议约定及平台规则规定为准。平台规则如有变更的，MassAI将提前予以公示。您可以对变更的内容充分表达意见；
      </p>
      <p>8.3 您在使用MassAI用户中的所有行为应遵守诚信原则，不得实施以下任一行为：</p>
      <p>8.3.1<strong>发布任何侵犯第三方合法权利的信息；</strong></p>
      <p>8.3.2发送钓鱼链接给其他用户；</p>
      <p>8.3.3通过发送病毒、木马等行为攻击其它用户的账户或机器；</p>
      <p>8.3.4冒充MassAI工作人员欺骗其他用户；</p>
      <p>8.3.5通过留言、评论等手段发送违规或垃圾信息；</p>
      <p>8.3.6协助他人获取不正当利益；</p>
      <p>8.3.7利用MassAI的漏洞，骗取相关利益；</p>
      <p>8.3.8平台规则规定的其他不当行为。</p>
      <p>8.4 不当评价</p>
      <p>您不得以虚构或歪曲事实的方式不当评价其他用户，不得以不正当手段提高或降低自身或其他用户信用度。</p>
      <p>8.5 不发布违法信息</p>
      <p>您不得发布国家法律法规、本协议及其平台规则所禁止发布的信息，也不得发布任何涉嫌侵犯他人知识产权等合法权益的信息。</p>
      <p>8.6 不危害平台正常交易运营、维护和安全措施</p>
      <p>您不得以任何方式危害MassAI的正常运营，包括不得实施如下任一行为：</p>
      <p>8.6.1以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件等非MassAI认可的方式访问或登录MassAI；</p>
      <p>8.6.2通过任何方式对MassAI造成或可能造成不合理的重大负荷；</p>
      <p>8.6.3通过任何方式干扰或试图干扰MassAI的正常运行。</p>
      <p>8.7&nbsp;<strong>同意接收广告、通知信息</strong></p>
      <p><strong>您同意接收来自MassAI的信息，包括但不限于操作提醒、活动通知等。为使您及时了解平台的相关信息，提升服务体验，MassAI或其合作的第三方可以在法律法规允许的范围内，通过短信、电话、邮件等各种方式向您提供前述信息。</strong></p>
      <p>8.8享受MassAI用户</p>
      <p>您享受MassAI用户时，应遵守法律法规及本协议约定。</p>
      <p><strong>九、MassAI的权利和义务</strong></p>
      <p>9.1 MassAI有义务在现有技术水平条件下，努力使整个MassAI正常运行，尽力避免MassAI用户中断或将中断时间限制在最短时间内，以保证用户正常使用服务。</p>
      <p>
        9.2&nbsp;<strong>用户已充分知悉和理解，因网上交易平台的特殊性，MassAI没有义务对所有用户使用MassAI用户的过程及行为进行事前及实时审查。但用户发生以下情形之一的，MassAI可以普通、非专业人员的知识水平标准或根据自己掌握的信息进行独立判断，MassAI有权采取包括但不限于限制用户登录、要求用户提供有关资料、发出警告通知、删除相关信息、中止或终止向用户提供MassAI用户、以网络公告等形式公布用户违法违约行为或依据平台规则对于违约用户进行的其他违规处理：</strong>
      </p>
      <p>9.2.1用户违反国家法律、法规、规章及规范性文件的；</p>
      <p>9.2.2用户违反本协议或任何平台规则的；</p>
      <p>9.2.3第三方向MassAI告知用户侵犯第三方合法权益的。</p>
      <p>9.3&nbsp;<strong>用户不得发布下列任何信息，否则，MassAI可在不通知用户的情况下对其采取删除、屏蔽、断开链接或依据平台规则对于违约用户进行其他的违规处理：</strong></p>
      <p>9.3.1恶意欺诈信息；</p>
      <p>9.3.2与平台服务无关的信息；</p>
      <p>9.3.3存在恶意评价信息；</p>
      <p>9.3.4试图或已经扰乱平台运营秩序的信息；</p>
      <p>9.3.5违反国家法律、危害国家安全统一、社会稳定、公序良俗，侮辱、诽谤、淫秽、暴力的，以及任何违反国家法律法规的信息；</p>
      <p>9.3.6侵害他人知识产权、商业秘密等合法权益的信息；</p>
      <p>9.3.7虚构事实、误导、欺骗他人的信息；</p>
      <p>9.3.8发布、传送、传播广告信息及垃圾信息；</p>
      <p>9.4 用户知悉并同意，当国家行政、司法机关主动依职权或者根据他人的投诉调查用户在MassAI上的相关行为时，MassAI有权予以配合，并将所掌握的信息提供给上述国家机关。</p>
      <p>9.5<strong>&nbsp;</strong><strong>用户知悉并同意，用户不得利用MassAI用户实施侵犯他人知识产权及其它合法权益的行为，如MassAI接到第三方投诉称用户侵权的，为防止侵权行为的继续扩大和及时解决纠纷，MassAI除依本协议规定采取措施外，MassAI还可以将用户的相关信息提供给投诉人。</strong></p>
      <p><strong>十、特别授权</strong></p>
      <p><strong>10.1&nbsp;</strong><strong>您同意MassAI或MassAI授权的第三方对您在MassAI上的行为的判断和相应处理决定对您具有约束力。</strong></p>
      <p><strong>10.2</strong><strong>您同意，MassAI可为履行本协议或提供MassAI用户的目的而收集、使用、存储您的用户信息，并同意本协议附件中《数据信息授权书》中关于将您的用户数据信息授权给平台的说明。</strong></p>
      <p><strong>十一、责任限制</strong></p>
      <p>11.1&nbsp;<strong>您理解并同意</strong>，MassAI会在现有技术水平和条件下尽最大努力向您提供服务，确保服务的连贯性和安全性；<strong>但MassAI不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力，大规模的病毒、木马和黑客攻击，系统不稳定，第三方服务瑕疵，政府管制等原因可能导致的服务中断、数据丢失以及其他的损失和风险。</strong></p>
      <p><strong>11.2</strong><strong>您同意，对MassAI上出现的网络链接信息，您应审慎判断其真实性和可靠性，除法律明确规定外，您应对依该链接信息进行的事项负责。</strong></p>
      <p>
        <strong>11.3</strong><strong>用户理解并同意，在使用MassAI用户的过程中，可能会遇到不可抗力等风险因素使MassAI用户发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。出现上述情况时，MassAI将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户造成的损失，MassAI将在法律允许的范围内免责。</strong>
      </p>
      <p><strong>11.4</strong><strong>在法律允许的范围内，MassAI对以下情形之一导致的服务中断或受阻不承担责任：</strong></p>
      <p><strong>11.4.1</strong><strong>受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；</strong></p>
      <p><strong>11.4.2</strong><strong>用户或MassAI的电脑软件、系统、硬件和通信线路出现故障；</strong></p>
      <p><strong>11.4.3</strong><strong>用户操作不当；</strong></p>
      <p><strong>11.4.4</strong><strong>用户通过非MassAI授权的方式使用服务；</strong></p>
      <p><strong>11.4.4</strong><strong>其他MassAI无法控制或合理预见的情形。</strong></p>
      <p><strong>11.5</strong><strong>MassAI依据本协议约定获得处理违法违规内容的权利，该权利不构成MassAI的义务或承诺，MassAI不能保证及时发现违法行为或进行相应处理。</strong></p>
      <p><strong>十二、服务中止和终止</strong></p>
      <p><strong>12.1&nbsp;</strong><strong>本协议在下述情形下自然终止：</strong></p>
      <p><strong>12.1.1</strong><strong>协议方签署新协议代替本协议的；</strong></p>
      <p><strong>12.1.2</strong><strong>通知终止：除本协议另有约定外，MassAI提前</strong><strong>15</strong><strong>（十五）日以书面形式（包括系统通知、短信通知、电子邮件等方式）通知您终止本协议。</strong></p>
      <p><strong>12.1.3</strong><strong>注销中止：您可以根据MassAI所展示的规则请求注销您的账户，注销完成时本协议终止。</strong></p>
      <p><strong>12.2</strong><strong>如发生下列任何一种情形，MassAI有权不经通知而中断、中止或终止向用户提供的服务，且不向该用户承担任何责任：</strong></p>
      <p><strong>12.2.1</strong><strong>用户未按本协议提供真实信息；</strong></p>
      <p><strong>12.2.2</strong><strong>用户违反相关法律法规或本协议的规定；</strong></p>
      <p><strong>12.2.3</strong><strong>按照法律规定或主管部门的要求；</strong></p>
      <p><strong>12.2.4</strong><strong>用户侵犯其他第三方合法权益的；</strong></p>
      <p>
        <strong>12.2.5</strong><strong>用户出现负面消息可能影响</strong><strong>&ldquo;</strong><strong>MassAI</strong><strong>&rdquo;</strong><strong>及</strong><strong>&ldquo;</strong><strong>MassAI</strong><strong>&rdquo;</strong><strong>名誉的；</strong>
      </p>
      <p><strong>12.2.6</strong><strong>出于安全的原因或其他必要的情形。</strong></p>
      <p><strong>12.3&nbsp;</strong><strong>用户有责任自行备份存储在使用MassAI用户中产生的数据和信息。</strong></p>
      <p><strong>12.4&nbsp;</strong><strong>您同意，即便在本协议终止及您的服务被终止后，MassAI仍有权：</strong></p>
      <p><strong>12.4.1</strong><strong>继续保存并使用您的用户信息；</strong></p>
      <p><strong>12.4.2</strong><strong>继续向您主张您在使用MassAI用户期间因违反法律法规、本协议及平台规则而应承担的责任。</strong></p>
      <p><strong>十三、本服务软件形式</strong></p>
      <p>若MassAI依托&ldquo;软件&rdquo;向您提供MassAI用户，您还应遵守以下约定：</p>
      <p>13.1 MassAI可能为不同的终端设备开发不同的软件版本，您应当根据实际需要选择下载合适的版本进行安装。</p>
      <p>13.2 如果您从未经合法授权的第三方获取本软件或与本软件名称相同的安装程序，MassAI将无法保证该软件能否正常使用，并对因此给您造成的任何损失不予负责。</p>
      <p>13.3 为了增进用户体验、完善服务内容，MassAI将不时提供软件更新服务(该更新可能会采取软件替换、修改、功能强化、版本升级等形式)。为了改善用户体验，保证服务的安全性和功能的一致性，MassAI有权对软件进行更新或者对软件的部分功能效果进行改变或限制。</p>
      <p>13.4 软件新版本发布后，旧版软件可能无法使用。MassAI不保证旧版软件继续可用及相应的客户服务，请您随时核对并下载最新版本。</p>
      <p>13.5 除非法律允许或MassAI书面许可，您不得从事下列行为：</p>
      <p>13.5.1 删除软件及其副本上关于著作权的信息；</p>
      <p>13.5.2 对软件进行反向工程、反向汇编、反向编译或者以其他方式尝试发现软件的源代码；</p>
      <p>13.5.3 对MassAI或其关联公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
      <p>13.5.4对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经合法授权的第三方工具/服务接入软件和相关系统；</p>
      <p>13.5.5修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论上述行为是否为商业目的；</p>
      <p>13.5.6通过非MassAI开发、授权的第三方软件、插件、外挂、系统，使用MassAI用户，或制作、发布、传播非MassAI开发、授权的第三方软件、插件、外挂、系统；</p>
      <p>13.5.7其他未经MassAI明示授权的行为。</p>
      <p><strong>十四、知识产权</strong></p>
      <p>14.1 MassAI在提供MassAI用户中提供的信息内容，包括但不限于网页、文字、图片、音频、视频、图表等的知识产权均归MassAI所有，用户在使用MassAI用户中所产生的内容的知识产权归用户或相关权利人所有。</p>
      <p>14.2 除另有特别声明外，MassAI提供MassAI用户时所依托软件的著作权、专利权及其他知识产权均归MassAI关联公司所有。</p>
      <p>14.3 MassAI在提供MassAI用户中所使用的&ldquo;MassAI&rdquo;等商业标识，其著作权或商标权归MassAI关联公司所有。</p>
      <p>14.4 如您通过MassAI推出的客户端软件使用MassAI用户，MassAI给予您一项个人的、不可转让、非独占及非排他性的许可，您只能为正当使用MassAI用户之目的使用该权利，不得将其用作任何目的，也不得随意复制、修改、编译或以任何其他方式处置这些权利。</p>
      <p><strong>十五、遵守当地法律监管</strong></p>
      <p>15.1 您在使用MassAI用户过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。</p>
      <p>15.2 您应避免因使用MassAI用户而使MassAI卷入政治和公共事件，否则MassAI有权暂停或终止对您的服务。</p>
      <p><strong>十六、隐私政策</strong></p>
      <p><strong>16.1</strong><strong>保护用户个人信息及隐私是MassAI的一项基本原则。MassAI严格保护您的个人信息安全。MassAI使用各种制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、使用或泄漏。除本协议有特殊约定外，相关内容详见MassAI《隐私政策》的规定。</strong></p>
      <p><strong>十七、管辖与法律适用</strong></p>
      <p><strong>17.1&nbsp;</strong><strong>本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</strong></p>
      <p><strong>17.2&nbsp;</strong><strong>若您和MassAI之间因本协议发生任何纠纷或争议，首先应友好协商解决；协商不成的，您和MassAI均同意将纠纷或争议提交至甲方所在地（惠州市惠城区）有管辖权的人民法院管辖。</strong></p>
      <p>17.3 本协议条款无论因何种原因部分无效，其余条款仍有效，对各方具有约束力。</p>
    </div>

    <div v-else v-html="content" class='cont'></div>
  </div>

</template>

<script>
import { getActivityRuleContent } from "@/api/picker/index.js";
export default {
  data() {
    return {
      type: '',
      isWX: '1',
      headerMsg: {
        url: "",
      },
      content: "",
    };
  },
  mounted() {
    //   this.rule()
    //  this.isWX = this.GetQueryString("wx");
    this.getContent()
  },

  methods: {
    replaceTextInRichContent(oldText, newText) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.content, 'text/html');
      const walker = document.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT, null, false);

      let node;
      while (node = walker.nextNode()) {
        if (node.nodeValue.includes(oldText)) {
          node.nodeValue = node.nodeValue.replace(oldText, newText);
        }
      }

      this.content = new XMLSerializer().serializeToString(doc).replace(/<!DOCTYPE html>/i, '');
    },

    getContent() {
      this.type = this.GetQueryString("type")
      // 16
      getActivityRuleContent({
        type: this.GetQueryString("type") || 16, // 教程类型: 2.选菜师教程，3.城市合伙人教程，4.无码商品教程，5.选菜师协议，6.城市合伙人协议，7选菜师攻略教程，8.店长攻略，9爆款活动规则,10拼单活动规则，11：打印说明文档，12 店长协议 13悦买用户协议，14悦卖用户协议 15菜老板协议  16 悦买隐私政策,17 悦卖隐私政策,18 选菜师隐私政策,19 菜老板隐私政策,
      }).then((res) => {
        // console.log(res);
        let result = res.content.content
          .replace(/&#x3c;/g, "<")
          .replace(/&#x3e;/g, ">")
          .replace(/&#x22;/g, '"');
        // let result2 = result1.replace(/&#x3e;/g,'>')
        this.content = result;
        // if(this.type==47){
        // this.replaceTextInRichContent('城市综合服务平台', 'MassAI');
        // }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    let title;
    // 39集体备课教程
    // 40快捷备课教程
    // 41独立备课教程
    console.log(to.query.type);
    switch (to.query.type) {
      case "26":
        title = "备课啦用户协议";
        break;
      case "16":
        title = "隐私协议";
        break;
      // case "24":
      //   title = "隐私政策协议";
      //   break;
      case "38":
        title = "发布试讲教程";
        break;
      case "30":
        title = "文件上传协议";
        break;
      case "39":
        title = "集体备课教程";
        break;
      case "40":
        title = "快捷备课教程";
        break;
      case "41":
        title = "独立备课教程";
        break;
      case "47":
        title = "用户协议";
        break;
      case "49":
        title = "";
        break;
      case "50":
        title = "拼购说明";
        break;
      case "55":
        title = "喜豆说明";
        break;
      case "56":
        title = "喜豆兑换规则";
        break;
      case "57":
        title = "提现说明";
        break;
      case "59":
        title = "混批说明";
        break;
      case "60":
        title = "退货运费规则";
        break;
      case "61":
        title = "圈子公告";
        break;
      default:
        //   title = "操作手册";
        break;
    }
    console.log(title);
    to.meta.title = title;
    document.title = title;
    next();
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: auto;
  overflow: auto;
  width: auto;
  padding: 0 10px;
  img {
    width: 371px;
  }
  .cont {
    height: fit-content;
    margin-top: 10px;
    text-align: left;
  }
  .mt {
    height: fit-content;
    margin-top: 0;
  }
}
</style>
